import { IFilterTag, IKeyFigure } from "src/api/server/extended-search.types";
import { SearchQueryParams, ISearchRequestParamsOmitCountry } from "src/components/pages/search/search.types";
import { mapLeverageProductsIndicationFromQuery } from "src/components/pages/search/utils/map-leverage-products-indication";
import { SortDirection } from "src/constants/sort-direction";

type IUrlFigure = Pick<IKeyFigure, "id" | "urlIdentifier">;

const getSortDirectionValue = (sortDirection: string) => (sortDirection === SortDirection.Descending ? 1 : 0);

export const mapTagsFromQuery = (urlParams: URLSearchParams, tags: IFilterTag[]): string[] => {
    const selectedTags = urlParams.get(SearchQueryParams.Tags)?.split(",") ?? [];

    return tags.filter(filterTag => selectedTags.includes(filterTag.urlIdentifier)).map(tag => tag.urlIdentifier);
};

const mapKeyFiguresFromQueryToSearchPayload = (urlParams: URLSearchParams, allFigures: readonly IUrlFigure[]) => {
    const result = [];

    for (const keyFigure of allFigures) {
        const keyFigureValue = urlParams.get(keyFigure.urlIdentifier);
        const keyFigureFound = keyFigureValue !== null && keyFigureValue.includes(";");
        if (keyFigureFound) {
            let minimum = Number.parseFloat(keyFigureValue.split(";")[0]);
            let maximum = Number.parseFloat(keyFigureValue.split(";")[1]);

            if (minimum > maximum) {
                [minimum, maximum] = [maximum, minimum];
            }

            result.push({
                id: keyFigure.id,
                min: Number.isNaN(minimum) ? undefined : minimum,
                max: Number.isNaN(maximum) ? undefined : maximum,
            });
        }
    }

    return result;
};

export const mapSearchQueryToSearchPayload = (
    urlParams: URLSearchParams,
    keyFigures: IUrlFigure[],
    tags: IFilterTag[],
    excludeNoMarketing: boolean = false
): ISearchRequestParamsOmitCountry => {
    const sortDirectionParam = urlParams.get(SearchQueryParams.SortDirection);
    const sortDirection = sortDirectionParam ? getSortDirectionValue(sortDirectionParam) : null;
    const sortByRankingParam = urlParams.get(SearchQueryParams.SortByRanking)?.trim();
    const sortByRankingId = sortByRankingParam ? keyFigures.find(figure => figure.urlIdentifier === sortByRankingParam)?.id : null;

    return {
        query: urlParams.get(SearchQueryParams.SearchTerm) ?? "",
        keyFigures: mapKeyFiguresFromQueryToSearchPayload(urlParams, keyFigures),
        tagsIds: mapTagsFromQuery(urlParams, tags),
        brokersIds: urlParams.get(SearchQueryParams.BrokerIds)?.split(",") ?? [],
        isInvestable: urlParams.get(SearchQueryParams.IsInvestable) === "true",
        isAtInvestable: urlParams.get(SearchQueryParams.IsAtInvestable) === "true",
        isChInvestable: urlParams.get(SearchQueryParams.IsChInvestable) === "true",
        leverageProductsIndication: mapLeverageProductsIndicationFromQuery(urlParams),
        sortDirection: sortDirection,
        sortByRankingId: sortByRankingId,
        excludeNoMarketing,
    };
};
